const getters = {
  loginInfo: state => state.user.loginInfo,
  hasLogin: state => state.user.hasLogin,
  loginLogoUrl: state => state.theme.loginLogoUrl,
}
export default getters